import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslations from '../locales/en.json';
import thTranslations from '../locales/th.json';

// Import service translations
import servicesEn from '../locales/services_en.json';
import servicesTh from '../locales/services_th.json';
import serviceFeaturesEn from '../locales/service_features_en.json';
import serviceFeaturesTh from '../locales/service_features_th.json';

const resources = {
  en: { translation: { ...enTranslations, service_pages: servicesEn, features: serviceFeaturesEn } },
  th: { translation: { ...thTranslations, service_pages: servicesTh, features: serviceFeaturesTh } }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'th'],
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
